import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/da0kn0u859p3u981e3rg";

type Status = "idle" | "success" | "error";

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // 蜜罐检测：若被机器人填写则静默返回成功，不提交
    const honeypot = String(data.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("感谢订阅！我们会在有新漫画与书评时第一时间通知你。");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key !== "company_alt" && value !== "") payload.append(key, String(value));
    });

    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const ok = res.ok && parsed?.code === "OK";
      if (ok) {
        setStatus("success");
        setMessage("感谢订阅！我们会在有新漫画与书评时第一时间通知你。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  }

  return (
    <div className="w-full">
      <form data-readdy-form onSubmit={handleSubmit} className="w-full">
        <div className="flex flex-col gap-3 sm:flex-row">
          <label htmlFor="nl-email" className="sr-only">邮箱地址</label>
          <input
            id="nl-email"
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="输入你的邮箱，接收最新书评与追更提醒"
            className="w-full flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
          />
          {/* 蜜罐字段，用于拦截自动提交的机器人 */}
          <input
            type="text"
            name="company_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅更新
          </button>
        </div>
        {status === "success" && (
          <p role="status" className="mt-3 flex items-center gap-1.5 text-sm text-accent-700">
            <i className="ri-checkbox-circle-line" aria-hidden="true"></i>{message}
          </p>
        )}
        {status === "error" && (
          <p role="alert" className="mt-3 flex items-center gap-1.5 text-sm text-primary-700">
            <i className="ri-error-warning-line" aria-hidden="true"></i>{message}
          </p>
        )}
      </form>
    </div>
  );
}